/** @jsxImportSource @emotion/react */
"use client";
import { forwardRef } from "react";

import type { HallowElement } from "../../../../types/hallowElement.types";
import type { HallowElementProps } from "../../../../types/hallowElementProps.types";
import type { WithAsChild } from "../../../../types/withAsChild.types";
import { determineElementFromAsChild } from "../../../../utils/determineElementFromAsChild";
import { Text } from "../../_core/Text/Text.emotion";

const Element: HallowElement = "div";

export type FullscreenModalItemProps = WithAsChild<
  HallowElementProps<typeof Element>
>;

export const FullscreenModalItem = forwardRef<any, FullscreenModalItemProps>(
  ({ asChild = false, children, ...props }, ref) => {
    const DeterminedElement = determineElementFromAsChild({
      asChild,
      hallowElement: Element,
    });

    return (
      <Text asChild={asChild} ref={ref} size="l" type="headline">
        <DeterminedElement {...props}>{children}</DeterminedElement>
      </Text>
    );
  },
);

FullscreenModalItem.displayName = "FullscreenModalItem";
